<template>
  <div class="profile-page" dir="rtl">
    <div class="profile-layout">
      <div class="form-panel">
        <div class="login-card-outer">
          <div class="form-grid">
            <div>
              <div class="input-group" :data-label="$t('userName')">
                <img class="input-icon" src="/img/user.svg" alt="user" />
                <input
                  v-model="user_name"
                  class="input"
                  type="text"
                />
              </div>
            </div>

            <div>
              <div class="input-group" :data-label="$t('userId')">
                <img class="input-icon" src="/img/notes.svg" alt="user" />
                <input
                  v-model="user_code"
                  class="input"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div class="actions">
            <button class="btn primary" @click="save_edit()">{{ $t('add') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import { bus } from '../../main'

  export default {
    data () {
      return {
        user_name :'',
        user_code :'',
        user_id : '',
        user_password: '',
        image_id: '',
        thumb_path: '',
        user_deviceNo: '',
        myprofile: '',
        error: []
      }
    },
    mounted () {
      this.profile()
    },
    methods: {
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        this.myprofile = user_data
        this.user_name = user_data.UserName
        this.user_code = user_data.UserCode
        this.user_id = user_data.UserId
        this.image_id = user_data.ImageId
        this.thumb_path = user_data.ThumbPath
        this.user_deviceNo = user_data.UserDeviceNo
        console.log(JSON.parse(localStorage.getItem('profile')))
        this.user_password = localStorage.getItem('password')
      },
      save_edit () {
        if (this.user_name == '' || this.user_name == ' ') {
          this.error.push(this.$t('userNameIsEmpty'))
        }
        if (this.user_code == '' || this.user_code == ' ') {
          this.error.push(this.$t('userIdIsEmpty'))
        }
        if (this.user_name != '' && this.user_code != '') {
          if (this.user_code.startsWith('@') == false) {
            var str1 = '@'
            this.user_code = str1.concat(this.user_code)
          }
          const send_data = {
            UserId:this.user_id,
            Password: this.user_password,
            UserName: this.user_name,
            UserCode: this.user_code
          }
          var self = this
          this.axios.post('/UpdateUserProfile', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response edit', response)

                self.myprofile.UserName = self.user_name
                self.myprofile.UserCode = self.user_code
                //   const profile = {
                //   "UserName": this.user_name,
                //   "UserCode": this.user_code,
                //   "UserId" : this.user_id,
                //   "ImageId": this.image_id,
                //   "ThumbPath": this.thumb_path,
                //   "UserDeviceNo": this.user_deviceNo
                // }
                bus.$emit('show_toast', [3000, response.data.msg])

                console.log('profile', JSON.stringify(self.myprofile))
                localStorage.setItem('profile', JSON.stringify(self.myprofile))
              } else {
                bus.$emit('show_toast', [3000, response.data.msg])
              }
            }).catch(e => {

            })
        }
      }
    }

  }
</script>
<style scoped>
  .profile-page {
    min-height: 100dvh;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 16px;
    background: #f1f5f9;
  }
  .profile-layout { width: 100%; max-width: 512px; }
  .form-panel { width: 100%; display: flex; align-items: flex-start; justify-content: center; padding-top: 20px; }

  .login-card-outer {
    width: 100%;
    background: #ffffff;
    border-radius: 15px;
    border: 0.5px solid rgba(163, 163, 163, 0.747);
    padding: 24px;
    /* box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.06),
      0 8px 16px rgba(0, 0, 0, 0.03); */
    border: 0.5px solid rgba(226, 232, 240, 0.4);
  }

  .form-grid > * + * { margin-top: 16px; }

  /* Input styles are now in global stylesheet */

  .actions { margin-top: 20px; }
  .btn {
    width: 100%;
    height: 56px;
    border: 0;
    border-radius: 15px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  .btn:hover::before { left: 100%; }
  .btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
  .btn:not(:disabled):hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(28, 57, 187, 0.25); }
  .primary { color: #ffffff; background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%); box-shadow: 0 4px 15px rgba(28, 57, 187, 0.2); }
</style>
